import { incYenOf } from '../../../lib/pricing';
const commercialLaw = {
  'commercialLaw.page.backToTop': 'Back to top',
  'commercialLaw.page.lastUpdated': 'Last updated: 13 June 2026',
  'commercialLaw.page.homeLink': 'Home',
  'commercialLaw.page.currentPage': 'Commercial Transactions Act Disclosure',

  'commercialLaw.hero.homeLink': 'Home',
  'commercialLaw.hero.currentPage': 'Commercial Transactions Act Disclosure',
  'commercialLaw.hero.title': 'Commercial Transactions Act Disclosure',
  'commercialLaw.hero.titleEn': 'COMMERCIAL TRANSACTIONS ACT',
  'commercialLaw.hero.lead': 'The following information is disclosed pursuant to Article 11 of the Act on Specified Commercial Transactions in respect of the educational services provided by The Japan Butler Academy, operated by The All Japan Butler Association.',
  'commercialLaw.hero.imgAlt': 'Commercial Transactions Act Disclosure',

  'commercialLaw.jsonld.breadcrumb1': 'Home',
  'commercialLaw.jsonld.breadcrumb2': 'Commercial Transactions Act Disclosure',
  'commercialLaw.jsonld.orgName': 'The Japan Butler Academy',
  'commercialLaw.jsonld.parentOrg': 'The All Japan Butler Association',

  'commercialLaw.related.title': 'Related Pages',
  'commercialLaw.related.0.title': 'Privacy Policy',
  'commercialLaw.related.0.desc': 'How we handle your personal information',
  'commercialLaw.related.1.title': 'Terms of Service',
  'commercialLaw.related.1.desc': 'Conditions of use for this website',
  'commercialLaw.related.2.title': 'Contact',
  'commercialLaw.related.2.desc': 'Questions and enquiries',
  'commercialLaw.related.viewMore': 'View',

  // CommercialLawContent UI chrome
  'commercialLaw.toc.heading': 'Contents',
  'commercialLaw.content.preamble': 'The following information is disclosed pursuant to Article 11 of the Act on Specified Commercial Transactions in respect of the educational services provided by The Japan Butler Academy, operated by The All Japan Butler Association. \n\nPlease also refer to the relevant pages for further details on each item.',
  'commercialLaw.content.enactDate': 'Effective Date',
  'commercialLaw.content.enactDateValue': 'To be announced',
  'commercialLaw.content.lastRevised': 'Last Revised',
  'commercialLaw.content.lastRevisedValue': '13 June 2026',
  'commercialLaw.content.amendNotice': 'The name of the representative will be updated on this page promptly once confirmed.',
  'commercialLaw.content.noteTitle': 'Notes',
  'commercialLaw.content.noteText': 'This disclosure is made pursuant to Article 11 of the Act on Specified Commercial Transactions in respect of the provision of services (educational services). Prices and other transaction terms are subject to change without notice. \n\nPlease refer to this website for the most up-to-date information.',

  // Item labels (used in TOC and as section headings)
  'commercialLaw.i.seller.label': 'Selling Operator',
  'commercialLaw.i.representative.label': 'Representative',
  'commercialLaw.i.address.label': 'Address',
  'commercialLaw.i.phone.label': 'Telephone Number',
  'commercialLaw.i.email.label': 'Email Address',
  'commercialLaw.i.price.label': 'Prices',
  'commercialLaw.i.extra-fees.label': 'Additional Charges',
  'commercialLaw.i.payment-method.label': 'Payment Method',
  'commercialLaw.i.payment-timing.label': 'Payment Timing',
  'commercialLaw.i.service-timing.label': 'Service Commencement Date',
  'commercialLaw.i.cancellation.label': 'Cancellation and Refunds',
  'commercialLaw.i.special-conditions.label': 'Special Sales Conditions',

  // Item content paragraphs
  'commercialLaw.i.seller.p.0': 'The All Japan Butler Association (Zennihon Shitsuji Kyokai)',
  'commercialLaw.i.seller.p.1': 'The Association is a general incorporated association that operates The Japan Butler Academy and provides butler education services.',

  'commercialLaw.i.representative.p.0': 'To be announced',
  'commercialLaw.i.representative.p.1': 'The name of the representative will be published on this page promptly once confirmed. The information is currently listed as "To be announced".',

  'commercialLaw.i.address.p.0': '2-7-4 Aomi, Koto-ku, Tokyo 135-0064',
  'commercialLaw.i.address.p.1': 'Approximately 5 minutes walk from Tokyo International Cruise Terminal Station on the Yurikamome Line. For detailed access information, please refer to the Access page.',

  'commercialLaw.i.phone.p.0': '03-6824-4086',
  'commercialLaw.i.phone.p.1': 'Office hours: Weekdays 10:00–17:00 (excluding weekends and public holidays)',
  'commercialLaw.i.phone.p.2': 'Please contact us by telephone during the above office hours. Enquiries outside these hours may be submitted via the enquiry form or by email.',

  'commercialLaw.i.email.p.0': 'info@butler-academy.jp',
  'commercialLaw.i.email.p.1': 'We also accept enquiries by email. Please feel free to contact us. Please note that responses may take 2–3 business days.',

  'commercialLaw.i.price.p.0': 'Course fees are as follows (all prices include consumption tax).',
  'commercialLaw.i.price.p.1': `· Essential Course: ¥${incYenOf('ac-essential')} (tax incl.)`,
  'commercialLaw.i.price.p.2': `· Advanced Course: ¥${incYenOf('ac-advanced')} (tax incl.)`,
  'commercialLaw.i.price.p.3': `· Master Course: ¥${incYenOf('ac-master')} (tax incl.)`,
  'commercialLaw.i.price.p.4': `· Trial Lesson: ¥${incYenOf('ac-trial')} (tax incl.)`,
  'commercialLaw.i.price.p.5': 'Corporate training fees are listed on the respective industry plan pages. Please refer to the pricing overview page and individual course pages for full details.',

  'commercialLaw.i.extra-fees.p.0': 'Bank transfer fees are at the expense of the student.',
  'commercialLaw.i.extra-fees.p.1': 'Where travel or accommodation costs arise in connection with off-site practical training or corporate training, actual costs will be charged.',
  'commercialLaw.i.extra-fees.p.2': 'Teaching materials are included in the course fee; no additional charge is required.',

  'commercialLaw.i.payment-method.p.0': 'Payment by bank transfer (lump-sum) only.',
  'commercialLaw.i.payment-method.p.1': 'Instalment payments and credit card payments are not accepted. We apologise for any inconvenience.',
  'commercialLaw.i.payment-method.p.2': 'For corporate training, payment by invoice (bank transfer) is accepted. Invoices will be issued approximately one month before the training date.',

  'commercialLaw.i.payment-timing.p.0': 'Course fees must be transferred at least 14 days before the course commencement date.',
  'commercialLaw.i.payment-timing.p.1': 'Payment timing for corporate training will be advised separately. In principle, payment is due within 30 days of receipt of invoice.',

  'commercialLaw.i.service-timing.p.0': 'Services commence on the course commencement date. Annual schedules are available on the Annual Schedule page.',
  'commercialLaw.i.service-timing.p.1': 'Corporate training will be delivered on the date agreed with the client.',
  'commercialLaw.i.service-timing.p.2': 'Trial lesson dates will be announced on this website once confirmed.',

  'commercialLaw.i.cancellation.p.0': 'As the Services involve the provision of educational services rather than the sale of goods, product returns do not apply.',
  'commercialLaw.i.cancellation.p.1': 'Cancellation and refund policies are governed by the Cancellation Policy set out in the Prospectus. Please refer to the Application Requirements & Enrolment Process page for details.',
  'commercialLaw.i.cancellation.p.2': 'Cancellations notified at least 14 days before the course commencement date will be refunded less an administrative fee. Cancellation fees vary depending on the number of days remaining before the course commencement date. \n\nPlease ensure you check the Prospectus.',

  'commercialLaw.i.special-conditions.p.0': 'Each course has a maximum of 6 participants and a minimum enrolment of 3 participants.',
  'commercialLaw.i.special-conditions.p.1': 'If the minimum enrolment is not met, the course may be cancelled. In such cases, the full course fee will be refunded.',
  'commercialLaw.i.special-conditions.p.2': 'Where a course is oversubscribed, places will be allocated on a first-come, first-served basis, and applicants will be notified of the next available course.',
};

export default commercialLaw;
